import type { ReactElement } from 'react';
import React from 'react';
import { StyleSheet } from 'react-native';
import { BodyText as Text } from '../../Text';
import type {
  TextParentProps,
  SizeTypes,
  PaletteTypes,
} from '../TagLabel.types';
import { TagLabelPalette, TagLabelSize } from '../TagLabel.types';
import { useTextStyles } from '../styles';

export const TextParent = (props: TextParentProps): ReactElement => {
  const {
    palette = TagLabelPalette.primary as PaletteTypes,
    size = TagLabelSize.medium as SizeTypes,
    children,
    ...rest
  } = props;

  const useStyleState = useTextStyles(palette, size);

  return (
    <Text style={[styles.buttonText, useStyleState()]} {...rest}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  buttonText: {
    textAlign: 'center',
    justifyContent: 'center',
  },
});
